import React from 'react';
import { Reveal } from '../Reveal';
import { attentionPillars, myTurnQueue } from '../../data/site';
const bandRule: Record<string, string> = {
  Intervene: 'bg-clay',
  Watch: 'bg-sand',
  Healthy: 'bg-sage'
};
export function Attention() {
  return <section id="attention" className="bg-cream" data-id="element-31" data-mp="oxuwag1pa1v7">
      <div className="mx-auto max-w-[1180px] px-5 py-20 sm:px-8 lg:py-28" data-id="element-32" data-mp="tqxrstq1fle1">
        <div className="max-w-[760px]" data-id="element-33" data-mp="yq0ysjpkw1on">
          <p className="micro-label text-[9px] text-gold-600" data-id="element-34" data-mp="yozctk70xus5">Attention</p>
          <h2 className="mt-4 font-display text-[32px] font-semibold leading-[1.1] tracking-[-0.03em] text-charcoal-700 sm:text-[40px]" data-id="element-35" data-mp="13o2hv4n08104">
            See what needs attention. Let healthy progress stay in the background.
          </h2>
          <p className="mt-5 text-[15.5px] leading-relaxed text-charcoal-500" data-id="element-36" data-mp="1cp0e30r7b485">
            KeyTurn Health continuously interprets blockers, timing, ownership, stale activity,
            dependencies, runway and opening significance - then brings forward the work that
            requires a person.
          </p>
        </div>

        <div className="mt-14 grid gap-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:gap-16" data-id="element-37" data-mp="1ui13v9o9jnpj">
          <div className="grid gap-8 sm:grid-cols-3 lg:grid-cols-1" data-id="element-38" data-mp="1pnn5cyeb10gn">
            {attentionPillars.map(pillar => <div key={pillar.title} className="border-t border-charcoal-700 pt-5" data-id="element-39" data-mp="1frjy5e4libmu">
                <h3 className="font-display text-[17px] font-semibold tracking-[-0.015em] text-charcoal-700" data-id="element-40" data-mp="2df26inuchbqb">
                  {pillar.title}
                </h3>
                <p className="mt-2.5 text-[13.5px] leading-relaxed text-charcoal-500" data-id="element-41" data-mp="28gqyminm1baq">
                  {pillar.body}
                </p>
              </div>)}
          </div>

          <Reveal data-id="element-42" data-mp="1yh9uw6rx57he">
            <div className="rounded-2xl border border-line bg-white p-5 shadow-sm sm:p-6" data-id="element-43" data-mp="1yjw225awdkz3">
              <div className="flex items-baseline justify-between gap-4 border-b border-line pb-4" data-id="element-44" data-mp="s30uxd0ekp1m">
                <p className="micro-label text-[9px] text-charcoal-400" data-id="element-45" data-mp="n1bgrohvvv9b">My Turn</p>
                <p className="text-[11.5px] text-charcoal-400" data-id="element-46" data-mp="3b937o6rga26k">Prioritised by what it unlocks</p>
              </div>

              <ol className="divide-y divide-line" data-id="element-47" data-mp="3f9dlu6pebywi">
                {myTurnQueue.map(item => <li key={item.task} className="flex gap-4 py-4" data-id="element-48" data-mp="31a5j53u0y8nk">
                    <span className={`mt-1 h-[38px] w-[3px] shrink-0 rounded-full ${bandRule[item.band]}`} aria-hidden="true" data-id="element-49" data-mp="368ffhhrhjfar" />
                    <div className="min-w-0" data-id="element-50" data-mp="2wdf48jtyhj3q">
                      <p className="text-[13.5px] font-medium leading-snug text-charcoal-700" data-id="element-51" data-mp="2ikpaft86r9w2">
                        {item.task}
                      </p>
                      <p className="mt-1 text-[11.5px] text-charcoal-400" data-id="element-52" data-mp="2ngmo1rs2e255">{item.unlocks}</p>
                    </div>
                  </li>)}
              </ol>

              <p className="mt-4 border-t border-line pt-4 text-[12px] leading-relaxed text-charcoal-400" data-id="element-53" data-mp="2dk1in5c4up0s">
                Get notified when a change matters to you - not every time the plan changes.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}